import { httpClient } from '../../api/client';

export type CcMode = 'RELAXED' | 'STANDARD' | 'STRICT';
export interface CcPathException { id: string; matchType: 'EXACT' | 'PREFIX'; path: string }
export interface CcDraft { enabled: boolean; mode: CcMode; pathExceptions: CcPathException[] }
export interface CcPolicyView {
  domainId: number;
  configured: boolean;
  policyVersion: number;
  defaultMode: CcMode;
  modes: CcMode[];
  policy: (Omit<CcDraft, 'mode'> & { mode: CcMode | 'OBSERVE'; templateVersion: number }) | null;
  publishState: string;
  dispatchEnabled: boolean;
  publication: {
    policyVersion: number;
    state: string;
    releaseId: number | null;
    code: string | null;
    message: string | null;
    dispatchedAt: string | null;
    completedAt: string | null;
  } | null;
}

// Reuse the shared JWT/guest-login/error chain. No copied token storage or direct fetch bypass.
export const ccApi = {
  get(domainId: number) {
    return httpClient.get<CcPolicyView>(`/api/v1/security/cc/domains/${domainId}`);
  },
  save(domainId: number, draft: CcDraft, expectedVersion: number) {
    return httpClient.put<CcPolicyView>(`/api/v1/security/cc/domains/${domainId}`, { ...draft, expectedVersion });
  }
};
